var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-wifi-1179031",
    transform: "translate(-0.078 -172.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247900",
    "data-name": "\\u8DEF\\u5F84 247900",
    d: "M22.047,174.383a29.186,29.186,0,0,0-20.48,8.141.973.973,0,0,1-.773.373.736.736,0,0,1-.658-.471.782.782,0,0,1,.218-.886,29.108,29.108,0,0,1,3.933-3.24,30.721,30.721,0,0,1,18.858-5.463,30.64,30.64,0,0,1,20.594,8.683.782.782,0,0,1,.114,1.191.829.829,0,0,1-1.233-.093,28.5,28.5,0,0,0-6.366-4.687,29.459,29.459,0,0,0-12.581-3.544c-.541-.029-1.079,0-1.625,0Z",
    transform: "translate(0)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247901",
    "data-name": "\\u8DEF\\u5F84 247901",
    d: "M138.251,343.467a24.8,24.8,0,0,1,17.3,6.875.772.772,0,0,1,.222,1.027.76.76,0,0,1-.939.337.835.835,0,0,1-.368-.247,22.635,22.635,0,0,0-12.526-6.182,23.183,23.183,0,0,0-19.683,5.9c-.111.1-.219.2-.331.3a.8.8,0,0,1-1.167.03.756.756,0,0,1,.074-1.137,20.983,20.983,0,0,1,2.17-1.864,24.912,24.912,0,0,1,14.742-5.042c.171,0,.337,0,.5,0Z",
    transform: "translate(-116.133 -164.162)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247902",
    "data-name": "\\u8DEF\\u5F84 247902",
    d: "M254.532,513.28a18.878,18.878,0,0,1,12.751,4.928,1.811,1.811,0,0,1,.474.589c.159.35.182.651-.167.9a.836.836,0,0,1-1.085-.063,16.428,16.428,0,0,0-4.074-2.892,17.423,17.423,0,0,0-19.726,2.7c-.457.432-.922.479-1.281.13s-.306-.817.184-1.263a18.842,18.842,0,0,1,12.923-5.034Z",
    transform: "translate(-232.455 -327.569)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247903",
    "data-name": "\\u8DEF\\u5F84 247903",
    d: "M370.333,683.84a11.834,11.834,0,0,1,8.164,3.272.889.889,0,0,1,.337,1.015c-.206.569-.868.634-1.373.142a9.626,9.626,0,0,0-4.269-2.472,10.1,10.1,0,0,0-9.982,2.468.814.814,0,0,1-1.036.189.725.725,0,0,1-.331-.88.9.9,0,0,1,.295-.432,11.82,11.82,0,0,1,8.195-3.3Z",
    transform: "translate(-348.288 -491.739)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247904",
    "data-name": "\\u8DEF\\u5F84 247904",
    d: "M516.764,858.671a3.1,3.1,0,0,1-3.135-3.134,3.137,3.137,0,1,1,3.135,3.134Z",
    transform: "translate(-494.653 -653.857)",
    fill: "#05cb24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.9cb98d21ecf1bf5ac536a16855f889f8.svg";
export { ForwardRef as ReactComponent };